export const pathImages = "https://navalmotor.com/mediaserver/web/"
// export const pathImages = "https://www.navalmotor.com/mediaserver/web/generac/react/"
// export const pathImages = ""

// export const deployRoute = ""
export const deployRoute = "/mercury/"
